import { __assign } from "tslib";
import { connectMediaStore, useMMSelector, useMMDispatchActions, } from './withOwnReduxStore';
import { setSearchQuery, setSearchInput, unsetSearchQuery, unsetSearchInput, } from '../actions';
import { getSearchQuery, getSearchInput } from '../selectors';
export var useSearch = function () { return (__assign(__assign({}, useMMSelector(function (state) { return ({
    searchQuery: getSearchQuery(state),
    searchInput: getSearchInput(state),
}); })), useMMDispatchActions({
    setSearchQuery: setSearchQuery,
    unsetSearchQuery: unsetSearchQuery,
    setSearchInput: setSearchInput,
    unsetSearchInput: unsetSearchInput,
}))); };
export default connectMediaStore(function (state) { return ({
    searchQuery: getSearchQuery(state),
    searchInput: getSearchInput(state),
}); }, { setSearchQuery: setSearchQuery, unsetSearchQuery: unsetSearchQuery, setSearchInput: setSearchInput, unsetSearchInput: unsetSearchInput });
//# sourceMappingURL=withSearch.js.map